import { TopBarThemedThemeModeConfig } from './types';

const dark: TopBarThemedThemeModeConfig = {
  topBarThemed: {
    headingColor: 'white',
    headingBGColor: '#505251', // Example dark background color
  },
};

export default dark;